// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-277c4990]:root{--primary:#0775ee;--background-dark-fallback:#46485e;--white:#fff;--secondary:#747ba2;--gray:#5f6269;--cc-btn-primary-bg:var(--primary)!important}.error-page[data-v-277c4990]{display:flex;justify-content:center;align-items:center;min-height:100vh}.error-page .title-container[data-v-277c4990]{text-align:center;color:#fff}.error-page .button[data-v-277c4990]{margin-top:2rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
